import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import Cookies from 'universal-cookie'

import { THEME } from 'types/active'
import { expirationDurations } from 'services/cookie.service'

import Icon from 'components/elements/Icon'

export const themes = {
  light: { name: 'light', class: '' },
  dark: { name: 'dark', class: 'dark-mode' },
}

type Props = {
  className?: string
}

const DarkModeToggle = ({ className }: Props) => {
  const [theme, setTheme] = useToggleDarkMode()

  return (
    <button className={className} onClick={() => setTheme(theme === THEME.DARK ? THEME.LIGHT : THEME.DARK)}>
      <Icon name={`${theme}` === THEME.DARK ? 'moon' : 'moon outline'} />
    </button>
  )
}

export default DarkModeToggle

type Theme = 'light' | 'dark' | undefined

export const useToggleDarkMode = (): [theme: string, setTheme: (value: string) => void, toggleTheme: () => void] => {
  const [{ theme: manuallySetTheme, settings }, setCookies] = useCookies(['theme', 'settings'])

  const handleSetTheme = (theme: string) => {
    const cookies = new Cookies()

    cookies.remove('theme', { path: '/' })

    setCookies('theme', theme, { maxAge: expirationDurations.year, path: '/' })

    if (`${theme}` === THEME.LIGHT) document.body.classList.remove(themes.dark.class)
    if (`${theme}` === THEME.DARK) document.body.classList.add(themes.dark.class)
  }

  const handleToggleTheme = () => {
    const updatedTheme = manuallySetTheme === THEME.LIGHT ? THEME.DARK : THEME.LIGHT

    handleSetTheme(updatedTheme)
  }

  useEffect(() => {
    const osPreferDark =
      typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? THEME.DARK
        : THEME.LIGHT

    const accountPreferDark = settings?.siteTheme === THEME.DARK ? THEME.DARK : THEME.LIGHT

    handleSetTheme(manuallySetTheme ?? accountPreferDark ?? osPreferDark)
  }, [])

  return [manuallySetTheme, handleSetTheme, handleToggleTheme]
}
